import React, { Component } from "react";
import {
  ActivityIndicator,
  FlatList,
  ScrollView,
  StyleSheet,
  TouchableNativeFeedback,
  View,
  Image,
  AppState,
  Alert,
  TouchableOpacity,
} from "react-native";
import { connect } from "react-redux";
import CheckGreen from "@assets/svg/CheckGreen";
import WhatsappDefault from "@assets/svg/WhatsappDefault.js";
import Text from "@components/AppText";
import CategoryHeader from "@components/CMS/CategoryHeader";
import AddnMinBtn from "@components/ProductDisplayUnit/AddnMinBtn";
import CommissionStrip from "@components/ProductDisplayUnit/CommissionStrip";
import DiscountStrip from "@components/ProductDisplayUnit/DiscountStrip";
import KhareedBtn from "@components/ProductDisplayUnit/KhareedBtn";
import NotifyButton from "@components/ProductDisplayUnit/NotifyButton";
import SliderBox from "@components/SliderBox";
import colors from "@constants/color";
import metrics, { normalize, width } from "@constants/metrics";
import {
  actions as cartActions,
  getAddedProductListIds,
} from "@reducers/cartReducer";
import { actions as customerActions } from "@reducers/customerReducer";
import { actions as productActions } from "@reducers/productReducer";
import analytics from "@services/analytics";
import {
  getProductFullDetails,
  getSuggestedProducts,
  notifyForOOS,
  setCartItem,
} from "@services/api";
import debounce from "@utils/debounce";
import handleFSPermission from "@utils/handleFSPermission";
import toast from "@utils/toast";
import { actions as refreshActions } from "@reducers/refreshReducer";
import refreshHOC from "@utils/refreshHOC";
import strings from "@constants";
import t from "@constants/localization";
import testIds from "@constants/testIds";
import GoToCustomerApp from "@components/GoToCustomerApp";
import GalleryModal from "../../components/GalleryModal";
import ImageComponent from "../../components/ProductDisplayUnit/ImageComponent";
import HorizontalProduct from "../../components/ProductDisplayUnit/HorizontalProduct";
import {
  ORDER_FLOW_EVENTS,
  SHARING_EVENTS,
} from "../../constants/analyticsEventsCT";
import parseTemplate from "../../utils/parseTemplate";
import { shareOnWhatsapp } from "../../utils/shareEntity";
import CartBottomStrip from "../Home/CartBottomStrip";

const PATH = "screens/ProductScreen";
const COMMON_PATH = "common";

const { refresh: refreshScreenName } = strings;
const formatPrice = (price) => {
  return price.split(".");
};

class ProductScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productDetails: {},
      isProductDetailsFetching: false,
      shouldDisplayTabBar: false,
      isCartValueLoading: false,
      count: 0,
      images: [],
      oosLoading: false,
      suggestedProducts: [],
      showTitle: false,
      isGalleryModalOpened: false,
      showCartActions: false,
      newVariantLoading: false,
      currentVariantIndex: null,
      currentVariantSlug: "",
      appState: AppState.currentState,
    };

    this.onlyOnce = false;
    this.lastUrl = "empty";
    this.tabList;
    this.clickedIndex = null;
    this.variantListRef = null;
    this.debounceAddToCart = debounce(this.addCart, 500);
    this.debounceRemoveFromCart = debounce(this.removeCart, 500);
  }

  async componentDidMount() {
    await this.fetchProductDetails();
  }

  componentDidUpdate(prevProps) {
    if (this.props.oosProducts.length !== prevProps.oosProducts.length) {
      this.setState({
        oosLoading: false,
      });
    }
  }

  handleGalleryModalOpen = (index) => {
    if (typeof index === "number") {
      this.clickedIndex = index;
    } else {
      this.clickedIndex = 0;
    }
    this.setState({
      isGalleryModalOpened: !this.state.isGalleryModalOpened,
    });
  };

  fetchProductDetails = async () => {
    try {
      this.setState({ isProductDetailsFetching: true });

      const { data: currentProduct } = await getProductFullDetails(
        this.productSlug,
      );
      let scrollIndex = currentProduct.children.findIndex(
        (el) => el.slug === this.productSlug,
      );

      scrollIndex = scrollIndex === -1 ? 0 : scrollIndex;

      const { data: suggestedProducts } = await getSuggestedProducts(
        this.productSlug,
      );

      this.setState(
        {
          productDetails: currentProduct,
          isProductDetailsFetching: false,
          images: currentProduct.images,
          suggestedProducts,
          currentVariantIndex: scrollIndex,
        },
        () => {
          setTimeout(() => {
            this.variantListRef?.scrollToIndex({
              animated: true,
              index: scrollIndex,
              viewPosition: 0.4,
            });
          }, 500);
          if (this.countOfItem(this.state.productDetails.sku_id) > 0) {
            this.setState({ showCartActions: true });
          }
        },
      );
    } catch (e) {
      console.log(e);
      return this.props.navigation.navigate("PageNotFound", {
        slug: this.productSlug,
        previousScreen: this.props.route?.params?.previousScreen,
      });
    }
  };

  selectVariantClick = async (slug, index) => {
    try {
      console.log("slug value now", slug);
      this.variantListRef.scrollToIndex({
        index,
        animated: true,
        viewPosition: 0.5,
      });
      this.setState({
        newVariantLoading: true,
        currentVariantIndex: index,
        currentVariantSlug: slug,
      });
      if (this?.props?.selectedContact) {
        this.props.dispatch(
          cartActions.viewCartLiteRequest(this.props.selectedContact),
        );
      }
      const { data: productDetails } = await getProductFullDetails(slug);
      const { data: suggestedProducts } = await getSuggestedProducts(slug);

      this.suggestedProductsRef?.scrollToIndex({
        animated: true,
        index: 0,
        viewOffset: normalize(15),
      });

      this.setState({
        productDetails,
        suggestedProducts,
        newVariantLoading: false,
        images: productDetails.images,
      });
    } catch (e) {
      console.log(e);
    }
  };

  onShareWhatsapp = async () => {
    console.log("here");
    await handleFSPermission(this.shareProductOnWhatsapp);
  };

  getMessageFromState = () => {
    const { leader_state } = this.props.user;
    const { LEADER_STATE_MESSAGES } = this.props.appSettings;
    if (leader_state === "PAYMENT_DONE") {
      return LEADER_STATE_MESSAGES.PAYMENT_DONE;
    }
    if (
      leader_state === "PAYMENT_PENDING" ||
      leader_state === "PAYMENT_REFUNDED"
    ) {
      return LEADER_STATE_MESSAGES.PAYMENT_PENDING;
    }
    return LEADER_STATE_MESSAGES.CANNOT_USE_APP;
  };

  checkLeaderState = () => {
    const { leader_state } = this.props.user;
    let CAN_ACCESS_APP = true;
    if (
      leader_state === "PAYMENT_DONE" ||
      leader_state === "PAYMENT_PENDING" ||
      leader_state === "PAYMENT_REFUNDED" ||
      leader_state === "ZERO_PAYMENT"
    ) {
      CAN_ACCESS_APP = false;
    }
    if (!CAN_ACCESS_APP) {
      Alert.alert("", this.getMessageFromState(), [
        {
          text: t(`${COMMON_PATH}/ok`),
          onPress: () => {},
        },
      ]);
      return false;
    }
    return true;
  };

  shareProductOnWhatsapp = () => {
    const {
      sku_id,
      mrp,
      price_tl_single_buy,
      shareSkuTemplate,
      images,
      product_name_hi,
      slug,
      discount,
      product_image,
    } = this.state.productDetails;

    const discount_price = mrp - price_tl_single_buy;
    const leaderName = this.props.user.name;
    const leaderId = this.props.user.user_id;

    if (!this.checkLeaderState()) {
      return;
    }

    const msg = parseTemplate(
      shareSkuTemplate,
      {
        mrp,
        price_tl_single_buy,
        product_name_hi,
        discount_price,
        leaderName,
        leaderId,
        slug,
      },
      "_",
    );

    analytics.trackEvent(SHARING_EVENTS.PRODUCT_SHARE, {
      screen_name: "ProductDetails",
      sku_id,
      price_tl_single_buy,
      product_name: product_name_hi,
    });
    shareOnWhatsapp({ message: msg, image: product_image });
  };

  trackEvent = (type, data) => {
    const { currentCartSkuIds } = this.props;
    const { sku_id, product_name_hi: product_name } = this.state.productDetails;
    switch (type) {
      case ORDER_FLOW_EVENTS.PRODUCT_ADDED:
        analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_ADDED, {
          products_in_cart: currentCartSkuIds,
          ...data,
          sku_id,
          product_name,
        });
        return;
      case ORDER_FLOW_EVENTS.PRODUCT_REMOVED:
        analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_REMOVED, {
          products_in_cart: currentCartSkuIds,
          ...data,
          sku_id,
          product_name,
        });
    }
  };

  addCart = (sku_id, cust_id, count) => {
    const apiPayload = {
      userId: cust_id,
      quantity: count || 1,
      skuId: sku_id,
    };
    this.setState({ isCartValueLoading: true });

    setCartItem(apiPayload)
      .then(({ data }) => {
        if (data.error) {
          toast.showShortToast(data.error);
        }
        data.items_in_cart = data?.result?.length;
        data.screen_name = this.props.route.name;
        this.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_ADDED, data);
        this.props.dispatch(
          cartActions.viewCartLiteSuccess(data, apiPayload.userId),
        );
        this.setState({ isCartValueLoading: false, count: null });
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isCartValueLoading: false, count: null });
      });
  };

  removeCart = (sku_id, user_id, count) => {
    const apiPayload = {
      userId: user_id,
      quantity: count || -1,
      skuId: sku_id,
    };
    this.setState({ isCartValueLoading: true });
    setCartItem(apiPayload)
      .then(({ data }) => {
        data.items_in_cart = data?.result?.length;
        this.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_REMOVED, data);
        this.props.dispatch(
          cartActions.viewCartLiteSuccess(data, apiPayload.userId),
        );
        this.setState({ isCartValueLoading: false, count: null });
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isCartValueLoading: false, count: null });
      });
  };

  getProductDiscountPercentage = (mrp = 0, sale_price = 0) => {
    if (!mrp && !sale_price) {
      return 0;
    }
    let percentage = 0;
    try {
      percentage =
        ((parseInt(mrp) - parseInt(sale_price)) / parseInt(mrp)) * 100;
    } catch (error) {
      console.log(error);
    }
    return Math.ceil(parseInt(percentage));
  };

  countOfItem = (sku_id) => {
    const { cartItems = [] } = this.props.cart;

    const selectedProduct =
      Array.isArray(cartItems) &&
      cartItems.length &&
      cartItems.find((c) => c.sku_id === sku_id && !c.discounted_product);

    return selectedProduct && selectedProduct.quantity;
  };

  getItemCount = (count) => {
    const { sku_id = "" } = this.state.productDetails || {};
    const itemCount = this.countOfItem(sku_id);
    let finalProductCount;
    if (itemCount) {
      if (count) {
        finalProductCount = itemCount + count;
      } else {
        finalProductCount = itemCount;
      }
    } else {
      if (count) {
        finalProductCount = count;
      }
    }
    return finalProductCount;
  };

  get productSlug() {
    if (
      this.props.route &&
      this.props.route.params &&
      this.props.route.params.slug
    ) {
      return this.props.route.params.slug;
    }
  }

  get isProductOutOfStock() {
    if (this.state.productDetails.product_status) {
      return this.state.productDetails.product_status === "OUT OF STOCK";
    }
    return false;
  }

  get isOutOfStockNotified() {
    const { productDetails } = this.state;

    if (productDetails.product_status) {
      return (
        (Array.isArray(this.props.oosProducts) &&
          this.props.oosProducts.findIndex(
            (p) => p.sku_id === productDetails.sku_id,
          ) !== -1) ||
        -1
      );
    }

    return false;
  }

  notifyOOS = () => {
    const { productDetails } = this.state;

    if (productDetails.product_status) {
      this.setState(
        {
          oosLoading: true,
        },
        () => {
          notifyForOOS({ sku_id: productDetails.sku_id })
            .then((res) => {
              this.props.dispatch(productActions.requestForOosSkus());
            })
            .catch((e) => {
              console.log(e);
            });
        },
      );
    }
  };

  renderItem = ({ item: product, index }) => {
    const { shareSkuTemplate } = this.state.productDetails;
    const leaderName = this.props.user.name;
    return (
      <HorizontalProduct
        data={product}
        index={index}
        defaultShare={true}
        sharingTemplate={shareSkuTemplate}
        leaderName={leaderName}
        trackEvent={this.trackEvent}
        horizontal={true}
        navigateMethod="replace"
      />
    );
  };

  getDescription = (text) => {
    const newArray = text.split("\\n");
    return newArray.map((el, _) => {
      if (el.startsWith("*")) {
        return (
          <View style={{ flexDirection: "row" }} key={el}>
            <View>
              <Text bold style={{ fontSize: normalize(12) }}>
                {"\u2022"}
              </Text>
            </View>
            <View
              style={{ flex: 1, marginLeft: 5, marginBottom: normalize(5) }}
            >
              <Text
                style={{
                  fontSize: normalize(14),
                  lineHeight: normalize(20),
                }}
              >
                {el.slice(1).trim()}
              </Text>
            </View>
          </View>
        );
      } else {
        return (
          <Text
            key={el}
            style={{
              fontSize: normalize(14),
              lineHeight: normalize(20),
              marginBottom: normalize(3),
            }}
          >
            {el.trim()}
          </Text>
        );
      }
    });
  };

  renderGramageItem = ({ item, index }) => {
    if (item.grammage) {
      return (
        <TouchableNativeFeedback
          onPress={() => this.selectVariantClick(item.slug, index)}
        >
          <View
            style={{
              paddingHorizontal: normalize(10),
              paddingVertical: normalize(7),
              borderColor:
                // grammage !== item.grammage
                this.state.currentVariantIndex === index
                  ? "#E40046"
                  : item.product_status === "Active"
                    ? "rgba(0, 0, 0, 0.5)"
                    : "rgba(0, 0, 0, 0.2)",
              borderWidth: 1,
              borderRadius: 6,
              marginRight: normalize(10),
              borderStyle:
                item.product_status === "OUT OF STOCK" ? "dashed" : "solid",
            }}
          >
            <Text
              style={{
                fontSize: normalize(16),
                color:
                  // grammage === item.grammage
                  item.product_status == "OUT OF STOCK"
                    ? "rgba(0,0,0,0.2)"
                    : this.state.currentVariantIndex === index
                      ? "#E40046"
                      : "rgba(0,0,0,0.86)",
              }}
            >
              {item.grammage}
            </Text>
          </View>
        </TouchableNativeFeedback>
      );
    } else {
      return <></>;
    }
  };

  render() {
    if (this.state.isProductDetailsFetching) {
      return (
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      );
    }

    const {
      short_name_hi = "",
      sku_id = "",
      slug = "",
      mrp = "",
      cm_price = "",
      price_tl_single_buy = "",
      product_description_hi = "",
      product_policy_hi = "",
      price_tl_commission = 0,
      discount,
      discount_type,
      grammage,
      price_per_unit,
      children,
      attributes = [],
      deliverySchedule = {},
      product_status,
      variant_identifier,
      custom_text = "",
      custom_symbol = "",
    } = this.state.productDetails || {};

    const { isQuantity, fromSalesReport } = this.props.route.params;
    const { isGalleryModalOpened, count, showCartActions } = this.state;

    const itemCount = isQuantity || this.countOfItem(sku_id);
    let finalProductCount;
    if (itemCount) {
      if (count) {
        finalProductCount = itemCount + count;
      } else {
        finalProductCount = itemCount;
      }
    } else {
      if (count) {
        finalProductCount = count;
      }
    }

    return (
      <View
        testID={testIds.Product_Screen_Details}
        style={{
          flex: 1,
          backgroundColor: "white",
          opacity: this.state.newVariantLoading ? 0.4 : 1,
        }}
      >
        <CategoryHeader
          title={this.state.showTitle && short_name_hi}
          shareOnWhatsapp={this.onShareWhatsapp}
          navigation={this.props.navigation}
          showWhatsappLogo={false}
          animation={true}
        />
        <ScrollView
          contentContainerStyle={{ minHeight: 100 }}
          onScroll={({ nativeEvent }) => {
            if (nativeEvent.contentOffset.y > 300) {
              if (this.state.showTitle) {
                return;
              }
              this.setState({ ...this.state, showTitle: true });
            } else if (this.state.showTitle) {
              this.setState({ ...this.state, showTitle: false });
            }
          }}
        >
          <View>
            <DiscountStrip discount={discount} discount_type={discount_type} />
            <View
              style={{
                opacity: this.isProductOutOfStock ? 0.5 : 1,
              }}
            >
              <SliderBox
                images={this.state.images?.map((image) => image.url)}
                ImageComponentStyle={{
                  width: "100%",
                  height: normalize(250),
                }}
                // sliderBoxHeight={330}
                resizeMode="contain"
                onCurrentImagePressed={this.handleGalleryModalOpen}
              />
              <GalleryModal
                handleGalleryModalOpen={this.handleGalleryModalOpen}
                data={
                  this.state.images.map((image) => ({ image: image.url })) || []
                }
                showModal={isGalleryModalOpened}
                shareOfferOnWhatsapp={() => {}}
                onClickTlOffer={() => {}}
                clickedIndex={this.clickedIndex}
              />
            </View>
            <View style={{ height: 1, backgroundColor: "rgba(0,0,0,0.1)" }} />
          </View>
          <View>
            <View
              style={{
                paddingVertical: normalize(10),
                paddingHorizontal: normalize(15),
                borderBottomWidth: 1,
                borderBottomColor: "rgba(0,0,0,0.1)",
              }}
            >
              <Text
                // fontType="head3"
                numberOfLines={3}
                ellipsizeMode="tail"
                bold
                style={{
                  fontSize: normalize(16),
                  lineHeight: normalize(24),
                  color: "rgba(0,0,0,0.86)",
                }}
              >
                {short_name_hi}
              </Text>
              {!this.isProductOutOfStock ? (
                <View>
                  <View
                    style={{ flexDirection: "row", marginTop: normalize(10) }}
                  >
                    <Text
                      bold
                      style={{
                        fontSize: normalize(18),
                        marginRight: normalize(10),
                        color: "black",
                      }}
                    >
                      ₹{formatPrice(price_tl_single_buy)[0]}
                      {formatPrice(price_tl_single_buy)[1] && (
                        <Text bold style={{ fontSize: normalize(12) }}>
                          .{formatPrice(price_tl_single_buy)[1]}
                        </Text>
                      )}
                    </Text>
                    <Text
                      style={{
                        lineHeight: normalize(16),
                        color: "rgba(0, 0, 0, 0.56)",
                        fontSize: normalize(15),
                        marginTop: normalize(6),
                        textDecorationLine:
                          parseFloat(mrp) !== parseFloat(price_tl_single_buy)
                            ? "line-through"
                            : "none",
                      }}
                    >
                      ₹{mrp}
                    </Text>
                  </View>
                  {price_per_unit ? (
                    <View
                      style={{
                        // justifyContent: "center",
                        alignItems: "flex-start",
                      }}
                    >
                      <Text
                        numberOfLines={2}
                        style={{
                          fontSize: normalize(13),
                          marginTop: normalize(5),
                          color: "rgba(0,0,0,0.5)",
                        }}
                      >
                        ({price_per_unit})
                      </Text>
                    </View>
                  ) : (
                    <></>
                  )}
                </View>
              ) : (
                <></>
              )}
              {this.isProductOutOfStock ? (
                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 5,
                  }}
                >
                  <View>
                    <Text style={{ color: "#FF2E00", fontSize: normalize(14) }}>
                      {t(`${PATH}/outOfStock`)}
                    </Text>
                  </View>
                  {!this.isOutOfStockNotified ? (
                    !this.state.oosLoading ? (
                      <NotifyButton
                        onPress={this.notifyOOS}
                        width={normalize(140)}
                      />
                    ) : (
                      <View style={{ width: "45%" }}>
                        <ActivityIndicator
                          size="small"
                          color={colors.primary}
                        />
                      </View>
                    )
                  ) : (
                    <View
                      style={{
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                        borderRadius: 6,
                        paddingHorizontal: 4,
                        flexDirection: "row",
                        alignItems: "center",
                        height: normalize(30),
                      }}
                    >
                      <CheckGreen />
                      <Text
                        style={{
                          color: "rgba(0, 0, 0, 0.56)",
                          fontSize: normalize(12),
                          marginLeft: normalize(2),
                        }}
                      >
                        {t(`${PATH}/willNotify`)}
                      </Text>
                    </View>
                  )}
                </View>
              ) : null}
            </View>
            <View
              style={{
                paddingVertical: normalize(10),
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "stretch",
                borderBottomWidth: 1,
                borderBottomColor: "rgba(0, 0, 0, 0.1)",
                opacity: product_status === "Active" ? 1 : 0.3,
              }}
            >
              <View
                style={{
                  flex: 1,
                  paddingHorizontal: width * 0.02,
                  alignItems: "flex-start",
                  justifyContent: "center",
                }}
              >
                <CommissionStrip
                  {...{
                    commission: price_tl_commission,
                    height: normalize(30),
                    fontSize: 16,
                  }}
                />
              </View>
              <View
                style={{
                  flex: 1,
                  paddingHorizontal: width * 0.02,
                  justifyContent: "center",
                  alignItems: "flex-end",
                }}
              >
                <TouchableNativeFeedback
                  onPress={this.onShareWhatsapp}
                  disabled={product_status !== "Active"}
                >
                  <View
                    style={{
                      borderWidth: 1,
                      borderColor: "#075E54",
                      paddingHorizontal: normalize(16),
                      height: normalize(30),
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: 6,
                      marginVertical: normalize(8),
                    }}
                  >
                    <WhatsappDefault />
                    <Text
                      bold
                      style={{
                        fontSize: normalize(14),
                        marginLeft: 2,
                      }}
                    >
                      {t(`${PATH}/share`)}
                    </Text>
                  </View>
                </TouchableNativeFeedback>
              </View>
              {/* <View
                style={{
                  flex: 1,
                  paddingHorizontal: width * 0.02,
                  paddingTop: normalize(11),
                }}>
                {this.props.selectedContact &&
                finalProductCount &&
                finalProductCount != 0 ? (
                  <AddnMinBtn
                    disabled={product_status !== "Active"}
                    onPressPlus={() => {
                      if (!this.checkLeaderState()) {
                        return;
                      }
                      const { count } = this.state;
                      const updatedCount = count === null ? 1 : count + 1;
                      this.setState({
                        count: updatedCount,
                      });
                      this.debounceAddToCart(
                        sku_id,
                        this.props.selectedContact?.user_id,
                        this.getItemCount(updatedCount),
                      );
                    }}
                    onPressMinus={() => {
                      if (!this.checkLeaderState()) {
                        return;
                      }
                      const { count } = this.state;
                      const updatedCount = count === null ? -1 : count - 1;
                      this.setState({
                        count: updatedCount,
                        showCartActions: !(updatedCount < 1),
                      });
                      this.debounceRemoveFromCart(
                        sku_id,
                        this.props.selectedContact.user_id,
                        this.getItemCount(updatedCount),
                      );
                    }}
                    isCartValueLoading={this.state.isCartValueLoading}
                    count={finalProductCount}
                  />
                ) : (
                  <KhareedBtn
                    testID={testIds.Add_Product_To_Cart}
                    disabled={product_status !== "Active"}
                    onPress={() => {
                      if (!this.checkLeaderState()) {
                        return;
                      }
                      const { count } = this.state;
                      const updatedCount = count === null ? 1 : count + 1;
                      if (this.props.selectedContact) {
                        this.setState({
                          count: updatedCount,
                        });
                        this.debounceAddToCart(
                          sku_id,
                          this.props.selectedContact.user_id,
                          this.getItemCount(updatedCount),
                        );
                      } else {
                        this.props.navigation.navigate("Customer", {
                          sku_id,
                          price_tl_single_buy,
                          product_name_hi:
                            this.state.productDetails.product_name_hi,
                          screen_name: "ProductDetails",
                        });
                      }
                    }}
                    isCartValueLoading={this.state.isCartValueLoading}
                    count={finalProductCount}
                  />
                )}
              </View> */}
            </View>
            <GoToCustomerApp
              {...{ slug, sku_id, price_tl_commission, price_tl_single_buy }}
            />
            {children && children.length > 0 ? (
              <View
                style={{
                  paddingHorizontal: normalize(15),
                  paddingBottom: normalize(20),
                }}
              >
                <Text
                  bold
                  style={{
                    marginVertical: normalize(10),
                    color: "rgba(0,0,0,0.86)",
                    fontSize: normalize(16),
                  }}
                >
                  {t(`${PATH}/select`)}
                </Text>
                <FlatList
                  horizontal
                  showsHorizontalScrollIndicator={false}
                  ref={(el) => {
                    this.variantListRef = el;
                  }}
                  onScrollToIndexFailed={() => {}}
                  data={children}
                  keyExtractor={(item, index) => `key-${item.sku_id || index}`}
                  renderItem={this.renderGramageItem}
                />
              </View>
            ) : null}

            <View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                  borderBottomWidth: 6,
                  borderTopWidth: 6,
                  borderColor: "#F8F8F8",
                  paddingVertical: normalize(20),
                }}
              >
                {attributes.map((el, idx) => {
                  return (
                    <View style={{ alignItems: "center" }} key={el.id}>
                      <ImageComponent uri={el.icon} resizeMode="contain" />
                      <Text
                        style={{
                          marginTop: normalize(6),
                          marginBottom: normalize(4),
                          color: "rgba(0, 0, 0, 0.56)",
                        }}
                      >
                        {el.text}
                      </Text>
                      {el.sub_text ? (
                        <Text bold style={{ fontSize: normalize(12) }}>
                          {el.sub_text}
                        </Text>
                      ) : (
                        <></>
                      )}
                    </View>
                  );
                })}
              </View>
            </View>
          </View>

          {deliverySchedule.show ? (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingHorizontal: normalize(15),
                paddingVertical: normalize(8),
              }}
            >
              <View>
                <Text
                  style={{
                    fontSize: normalize(14),
                    lineHeight: normalize(20),
                  }}
                >
                  {deliverySchedule.deliveryText}
                </Text>
              </View>
              <View
                style={{
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                }}
              >
                <Text
                  bold
                  style={{
                    fontSize: normalize(14),
                    lineHeight: normalize(20),
                  }}
                >
                  {deliverySchedule.deliveryDate}
                </Text>
                <Text
                  style={{
                    fontSize: normalize(12),
                    lineHeight: normalize(20),
                  }}
                >
                  {deliverySchedule.ifOrderedSchedule}
                </Text>
              </View>
            </View>
          ) : null}
          <View style={{ height: 6, backgroundColor: "#F8F8F8" }} />

          {custom_symbol && custom_text ? (
            <View
              style={{
                flexDirection: "row",
                // alignItems: "flex-start",
                // paddingHorizontal: normalize(10),
                marginBottom: normalize(10),
                // alignSelf: "center",
                alignItems: "center",
                borderBottomColor: "#F8F8F8",
                borderBottomWidth: 6,
                paddingVertical: normalize(20),
              }}
            >
              <View
                style={{ paddingTop: normalize(2), marginLeft: normalize(12) }}
              >
                <Image
                  resizeMode="contain"
                  source={{
                    uri: custom_symbol,
                  }}
                  style={{ height: normalize(20), width: normalize(20) }}
                />
              </View>
              <View
                style={{
                  paddingHorizontal: normalize(5),
                  // backgroundColor: "blue",
                  flex: 1,
                }}
              >
                <Text
                  bold
                  style={{
                    color: "rgba(0, 0, 0, 0.56)",
                    fontSize: normalize(14),
                  }}
                  numberOfLines={2}
                  ellipsizeMode="tail"
                >
                  {custom_text}
                </Text>
              </View>
            </View>
          ) : (
            <></>
          )}

          {product_description_hi && product_description_hi.length > 1 ? (
            <>
              <View
                style={{
                  flex: 1,
                  paddingBottom: normalize(10),
                }}
              >
                <View
                  style={{
                    paddingVertical: normalize(11),
                    paddingHorizontal: width * 0.04,
                    borderBottomWidth: 1,
                    borderBottomColor: "rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Text
                    bold
                    style={{
                      fontSize: normalize(16),
                    }}
                  >
                    {t(`${PATH}/prodDescription`)}
                  </Text>
                </View>
                <View
                  style={{
                    paddingHorizontal: normalize(15),
                    paddingTop: normalize(10),
                  }}
                >
                  {this.getDescription(product_description_hi)}
                </View>
              </View>
            </>
          ) : (
            <></>
          )}

          {product_policy_hi && product_policy_hi.length > 1 ? (
            <>
              <View
                style={{
                  flex: 1,
                  paddingBottom: normalize(10),
                }}
              >
                <View
                  style={{
                    paddingVertical: normalize(11),
                    paddingHorizontal: width * 0.04,
                    borderBottomWidth: 1,
                    borderBottomColor: "rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Text
                    bold
                    style={{
                      fontSize: normalize(16),
                    }}
                  >
                    {t(`${PATH}/prodPolicy`)}
                  </Text>
                </View>
                <View
                  style={{
                    paddingHorizontal: normalize(15),
                    paddingTop: normalize(10),
                  }}
                >
                  {this.getDescription(product_policy_hi)}
                </View>
              </View>
            </>
          ) : (
            <></>
          )}

          <View style={{ height: 10, backgroundColor: "#F8F8F8" }} />
          {this.state.suggestedProducts.length > 0 ? (
            <>
              <Text
                bold
                style={{
                  marginHorizontal: 20,
                  fontSize: 20,
                  lineHeight: 28,
                  marginVertical: normalize(10),
                  color: "rgba(0, 0, 0, 0.86)",
                }}
              >
                {t(`${PATH}/frequentlyBoughtTogether`)}
              </Text>

              <FlatList
                ref={(el) => (this.suggestedProductsRef = el)}
                horizontal
                data={this.state.suggestedProducts}
                keyExtractor={(item) => item.sku_id}
                renderItem={this.renderItem}
                onScrollToIndexFailed={() => {}}
                contentContainerStyle={{
                  paddingHorizontal: 15,
                  marginBottom: 20,
                }}
                showsHorizontalScrollIndicator={false}
              />
              <View style={{ height: this.props.selectedContact ? 60 : 10 }} />
            </>
          ) : (
            <View style={{ height: this.props.selectedContact ? 90 : 40 }} />
          )}
        </ScrollView>
        {this.props.selectedContact ? (
          <CartBottomStrip
            bottom={{ bottom: 0 }}
            orderClick={() => {
              this.props.navigation.push("ConfirmOrder");
              analytics.trackEvent(ORDER_FLOW_EVENTS.CHECKOUT_STARTED, {
                screen: "CART_SCREEN",
                cart_value: this.props.cartDetails.total,
                cart_quantity: Array.isArray(this.props.cartItems)
                  ? this.props.cartItems.reduce(
                      (acc, curr) => (acc += curr.quantity),
                      0,
                    )
                  : "",
              });
            }}
            onCrossClick={() => {
              this.props.dispatch(customerActions.setSelectedContact(false));
              analytics.trackEvent(ORDER_FLOW_EVENTS.CX_CANCELLED);
            }}
            total={this.props.cartDetails.total}
            item={this.props.cartItems.length}
            name={this.props.selectedContact.user_name}
          />
        ) : null}
      </View>
    );
  }
}

const mapStateToProps = ({
  cart,
  products,
  auth: { user },
  configReducer: { appSettings },
  customer,
}) => {
  return {
    cart,
    oosProducts: products.oosProducts,
    user,
    currentCartSkuIds: getAddedProductListIds(cart),
    selectedContact: customer.selectedContact,
    cartDetails: cart.cartDetails,
    cartItems: cart.cartItems,
    appSettings,
  };
};

export default connect(mapStateToProps)(
  refreshHOC(refreshScreenName.pdp)(ProductScreen),
);
